<script setup lang="ts">
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import { Typography } from '@apparatix/library/core';
import PlusIcon from '@primeicons/vue/plus';

interface AssociationListContainerProps {
  title: string;
  itemCount?: number;
  noItemsMessage?: string;
  hideAddButton?: boolean;
  showAssociateAccountButton?: boolean;
}

const props = withDefaults(defineProps<AssociationListContainerProps>(), { itemCount: 0, noItemsMessage: 'No items to display' });
const emit = defineEmits<{
  (e: 'on:add-click'): void;
  (e: 'on:connect-click'): void;
}>();

</script>
<template>
  <div class="flex flex-col w-full">
    <div class="flex items-center pb-4 mb-4 border-b border-[var(--neutral-background)]">
      <div class="grow flex items-center gap-3">
        <Typography variant="section-heading">
          {{ props.title }}
        </Typography>
        <Badge severity="secondary" :value="props.itemCount" />
      </div>
      <div v-show="!props.hideAddButton" class="grow-0">
        <Button
          severity="secondary"
          :disabled="props.hideAddButton"
          @click="emit('on:add-click')"
        >
          <PlusIcon />
          Add
        </Button>
      </div>
      <div v-show="props.showAssociateAccountButton" class="grow-0">
        <Button
          severity="secondary"
          @click="emit('on:connect-click')"
        >
          <PlusIcon />
          Link Account
        </Button>
      </div>
    </div>
    <div v-if="itemCount > 0" class="flex flex-col gap-4">
      <slot />
    </div>
    <div v-else class="flex items-center">
      <p>{{ props.noItemsMessage }}</p>
    </div>
  </div>
</template>
